import React, { useContext, useState, useEffect } from "react";
import client from "client";

import { QueryBuilderContextProvider } from "contexts/QueryBuilderContextProvider";
import { AppContext } from "contexts/AppContextProvider";

import { ApolloProvider, useQuery } from "@apollo/client";

import QueryStructure from "components/QueryBuilder/QueryStructure";
import QueryDataRequest from "components/QueryBuilder/QueryDataRequest";
import QueryResults from "components/QueryBuilder/QueryResults";

import QueryInsightsFeed from "components/QueryBuilder/QueryInsightsFeed";
import QuerySave from "components/QueryBuilder/QuerySave";

import {
  CUSTOM_DATE_RANGES,
  LOAD_QUERY,
} from "components/QueryBuilder/QueryBuilderQueries";

import * as Sentry from "@sentry/browser";

const QueryBuilder = () => {
  const { currentProject } = useContext(AppContext).state;

  const hashParams = window.location.hash.substr(1);
  const tenantID = parseInt(localStorage.defaultTenantID);

  const [pastedQuery, setPastedQuery] = useState(null);

  let { data: dateRanges } = useQuery(CUSTOM_DATE_RANGES, {
    variables: {
      tenantID: parseInt(localStorage.defaultTenantID),
    },
    client,
  });

  dateRanges = dateRanges?.timeRanges || [];
  // If we have hash param load saved query
  const { data, error, loading } = useQuery(LOAD_QUERY, {
    variables: {
      tenantID: tenantID,
      queryID: hashParams,
    },
    skip: !hashParams,
    client,
  });

  // Get full query from short url
  useEffect(() => {
    if (data) {
      setPastedQuery(JSON.stringify(JSON.parse(data.loadQuery.query)));
    }

    if (error) {
      Sentry.captureException(error.error);
    }
  }, [data, error, hashParams, tenantID]);

  useEffect(() => {
    if (currentProject) {
      window.analytics.track("Query Page Load", {
        page_name: currentProject.page,
        project: currentProject.project,
        board: currentProject.board,
      });
    }
  }, [currentProject]);

  if (!currentProject) return null;

  const setNewQuery = (query) => {
    setPastedQuery(query);
  };

  // Get short url if it exists before rendering.
  const renderQueryBuilder = () => {
    if (hashParams) {
      if (pastedQuery && !loading) {
        return (
          <>
            <QuerySave setNewQuery={setNewQuery} dateRanges={dateRanges} />
            <QueryStructure
              pastedQuery={pastedQuery}
              projectId={currentProject.projectObj.id}
              dateRanges={dateRanges}
            />
            <QueryDataRequest projectId={currentProject.projectObj.id} />
            <QueryResults pastedQuery={pastedQuery} dateRanges={dateRanges} />

            {<QueryInsightsFeed projectId={currentProject.projectObj.id} />}
          </>
        );
      }
    } else {
      return (
        <>
          <QuerySave setNewQuery={setNewQuery} dateRanges={dateRanges} />
          <QueryStructure
            projectId={currentProject.projectObj.id}
            dateRanges={dateRanges}
          />
          <QueryDataRequest projectId={currentProject.projectObj.id} />
          <QueryResults dateRanges={dateRanges} />
          {<QueryInsightsFeed projectId={currentProject.projectObj.id} />}
        </>
      );
    }
  };

  return (
    <ApolloProvider client={client}>
      <QueryBuilderContextProvider>
        <div className="container-wrapper source-wrapper">
          <main className="container-fluid pb-5">{renderQueryBuilder()}</main>
        </div>
      </QueryBuilderContextProvider>
    </ApolloProvider>
  );
};

export default QueryBuilder;
